<template>
  <VDialog v-model="deleteDialog" width="500">
    <VCard>
      <VCardTitle class="headline grey lighten-2" primary-title>
        {{ $t("delete_confirmation") }}
      </VCardTitle>

      <VCardText> {{ $t("are_you_sure") }} </VCardText>

      <VDivider></VDivider>

      <VCardActions>
        <v-spacer></v-spacer>
        <VBtn variant="text" @click="cancel"> {{ $t("cancel") }} </VBtn>
        <VBtn color="error" variant="flat" @click="callDelete">
          {{ $t("confirm") }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
<script lang="ts" setup>
const deleteDialog = defineModel<boolean>();

const emit = defineEmits(["delete", "cancel"]);

const cancel = () => {
  deleteDialog.value = false;
  emit("cancel");
};

const callDelete = () => {
  deleteDialog.value = false;
  emit("delete");
};
</script>
